import { render, staticRenderFns } from "./storyBoard.vue?vue&type=template&id=0e46e74e&scoped=true"
import script from "./storyBoard.vue?vue&type=script&lang=js"
export * from "./storyBoard.vue?vue&type=script&lang=js"
import style0 from "./storyBoard.vue?vue&type=style&index=0&id=0e46e74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e46e74e",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QScrollArea,QCard,QBtn,QDialog});
